import { Environment } from '../utils/environment';

const env = new Environment();

/**
 * AbstractModule: This Class will be extended by every Module/Class and adds the element to the Class it has been called in
 *
 * Example: If the Form Class is initialized on element .js-nav with the selector data-module="Nav"
 *          then this.el and this.$el represent the .js-nav element.
 *          When you want to do something with the .js-nav element you can call this.$el
 *
 */
class AbstractModule {
    constructor (target) {
        //console.log('Super: AbstractModule has been loaded', target);

        this.$document = env.$document;
        this.$window = env.$window;
        this.$html = env.$html;
        this.$body = env.$body;
        this.$el = target.$el;
        this.el = target.el;
    }
}

export default AbstractModule;


// WEBPACK FOOTER //
// ./app/src/js/modules/AbstractModule.js